import jsonLogic from '@/plugins/jsonLogic'
import L from 'lodash'

export default {
  name: 'FormMixin',

  props: {
    /**
     * Field editability function: when not provided all fields are considered editable
     */
    userCanEditField: {
      type: Function,
      default: () => true
    },

    jsonLogicContext: {
      type: Object,
      default: () => (null)
    }
  },

  methods: {
    computedFormField (fieldId, field, {
      formModel,
      jsonLogicContext
    } = {}) {
      let dynamicProps = {}

      // Dynamic props resolution based on jsonLogic o function
      if (field.propsWhen) {
        dynamicProps = this.processPropsWhen(field, dynamicProps, formModel)
      }

      field = Object.assign({}, field, dynamicProps)

      if (field.api) {
        dynamicProps.api = this.processApi(field, jsonLogicContext)
      }

      // Check editabiliy on the field: force disabled = true when user does not have edit permissions
      if (!this.userCanEditField(fieldId)) {
        dynamicProps.disabled = true
      }

      return Object.assign({}, field, dynamicProps)
    },

    processPropsWhen (field, dynamicProps, formModel = null) {
      formModel = formModel || this.value || {}
      return Object.entries(field.propsWhen).reduce((acc, [prop, statment]) => {
        if (statment.jsonLogic) { // using jsonLogic
          return Object.assign({}, acc, {
            [prop]: jsonLogic.apply(statment.jsonLogic, formModel)
          })
        } else if (typeof statment === 'function') { // using fn
          return Object.assign({}, acc, {
            [prop]: statment(formModel)
          })
        }
        return acc
      }, dynamicProps)
    },

    // method used to resolve the json logic in the api filed 'filterTerms'
    // the method resolve json logic for the 'value' in the filterTerms object with
    // the json logic context passing by the component
    processApi (field, jsonLogicContext = null) {
      jsonLogicContext = jsonLogicContext || this.jsonLogicContext || this.value || {}
      const processField = L.cloneDeep(field)
      return Object.entries(processField.api).reduce((acc, [prop, statment]) => {
        if (statment.jsonLogic) {
          return Object.assign({}, acc, {
            [prop]: jsonLogic.apply(statment.jsonLogic, jsonLogicContext)
          })
        }
        if (statment.filterTerms) {
          return Object.assign({}, acc, {
            [prop]: Object.assign(statment, { filterTerms: statment.filterTerms.map(filterTerm => {
              if (filterTerm.value?.jsonLogic) {
                filterTerm.value = jsonLogic.apply(filterTerm.value.jsonLogic, jsonLogicContext)
              }
              return filterTerm
            }) })
          })
        } else {
          return Object.assign({}, acc, {
            [prop]: statment
          })
        }
      }, {})
    }
  }
}
